import {
  IAuthenticationContext,
  EActiveTab,
  EActiveView,
  ESentEmailType,
  EEventType,
} from '@cian/authentication-widget';
import { openAuthenticationPopup } from '../../services/authentication';

export interface IWaitForRegistrationPopupFactoryParameters {
  authenticationContext: IAuthenticationContext;
  defaultCallback(): void;
}

export const waitForRegistrationPopupFactory = ({
  authenticationContext,
  defaultCallback,
}: IWaitForRegistrationPopupFactoryParameters) => {
  return () => {
    authenticationContext.resetAuthentication();
    authenticationContext.setTab(EActiveTab.Registration);
    authenticationContext.setView(EActiveView.AuthenticationRegistration);

    let isRegistered = false;

    const handleRegisterSucceed = () => {
      isRegistered = true;
    };

    const handleSocialAuthenticateSucceed = ({ isNewUser }: { isNewUser: boolean }) => {
      if (!isNewUser) {
        defaultCallback();
      } else {
        isRegistered = true;
      }
    };

    const handleEmailSentClosed = ({ type }: { type: ESentEmailType }) => {
      if (type === ESentEmailType.Registration) {
        defaultCallback();
      }
    };

    authenticationContext.on(EEventType.AuthenticateSucceed, defaultCallback);
    authenticationContext.on(EEventType.SocialAuthenticateSucceed, handleSocialAuthenticateSucceed);
    authenticationContext.on(EEventType.EmailSentClosed, handleEmailSentClosed);
    authenticationContext.on(EEventType.RegisterSucceed, handleRegisterSucceed);

    openAuthenticationPopup({
      context: authenticationContext,
      onClose: () => {
        if (isRegistered) {
          defaultCallback();
        }

        authenticationContext.off(EEventType.AuthenticateSucceed, defaultCallback);
        authenticationContext.off(EEventType.SocialAuthenticateSucceed, handleSocialAuthenticateSucceed);
        authenticationContext.off(EEventType.EmailSentClosed, handleEmailSentClosed);
        authenticationContext.off(EEventType.RegisterSucceed, handleRegisterSucceed);
      },
    });
  };
};
